
import { getChannelRefer } from './appBase'
import { detectEnv } from './yUtil';

const { kbChannel, kbRefer, qbPosID = '816971', qbChannel='11813' } = getChannelRefer()

export const browserType = {
  1: 'qb',
  2: 'extreme_qb',
  3: 'novel_qb',
  4: 'young_qb'
}

export const CHECK_API = {
    qb: 'SQB.checkQB',
    ff: 'SQB.checkFF',
    kb: 'SQB.checkKB',
    extreme_qb: 'SQB.checkSG_Extreme',
    novel_qb: 'SQB.checkSG_Novel',
    young_qb: 'SQB.checkSG_Young'
}

export const OPEN_API = {
    qb: 'SQB.openQB',
    ff: 'SQB.openFF',
    kb: 'SQB.openKB',
    extreme_qb: 'SQB.openSG_Extreme',
    novel_qb: 'SQB.openSG_Novel',
    young_qb: 'SQB.openSG_Young'
}

export let APP_INFO = {
    qb: {
      app: 'qqbrowser',
      channel: '11809',
      appName: 'QQ浏览器',
      taskName: 'QQ浏览器—我的兴趣世界',
      wxAppId: 'wx64f9cf5b17af074d',
      qqAppId: '100446242',
      logo: 'http://res.imtt.qq.com/tagapp/qblogo_android_512.png',
      pkgName: 'com.tencent.mtt',
      scheme: 'mttbrowser://',
      schemeTl: 'https://news.html5.qq.com/feeds?ch=',
      schemeNormalVideoTl: 'qb://tab/video',
      schemeMiniVideoTl: 'qb://tab/video',
      schemeMainTL: detectEnv().isIos ? 'qb://home' : 'qb://home,openType=1',
      PosID: qbPosID,
      welfareCenter: 'https://qbact.html5.qq.com/newtickets?addressbar=hide&sdi_from=personalPage&isAutoLogin=true',
      downloadUrl: `https://appchannel.html5.qq.com/directdown?a=1&app=qqbrowser&channel=${qbChannel}`,      // TBS下载链接
      downloadUrlNotTBS: `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=${qbChannel}`, // 非TBS下载链接
      hotRank: {
        toMoreUrl: 'https://so.html5.qq.com/page/real/search_result?q=热搜榜&jump_from=2&entryTime=1582597704775&entryContent=搜索或输入网址&searchPageContent=搜索或输入网址&entryScene=001&entryStatus=001&searchPageStatus=002',
        toSearchEndUrl: 'https://so.html5.qq.com/page/real/search_result?q={keyword}'
      },
      downloadEcommerceUrl: `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=1100111356`,      // 电商渠道下载链接
      downloadEcommerceUrlNotTbs: `https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100111391`,      // 电商渠道分TBS下载链接
      downloadEcommerceUrliOS: `https://apps.apple.com/app/apple-store/id370139302?pt=69276&ct=191620203468&mt=8`,
      developer: '深圳市腾讯计算机系统有限公司',
      privacyAgreementUrl: "https://privacy.tencent.com/document/priview/2491347092a64d7fa00cbc2bf68fbbbb?addressbar=hide",
      permissionUrl: "https://upage.imtt.qq.com/app-info/qb.html"
    },
    ff: {
      app: 'qbspeed',
      channel: '11707',
      appName: '天天快报极速版',
      taskName: '天天快报极速版-腾讯王卡,全网免流量',
      wxAppId: 'wx64f9cf5b17af074d',
      qqAppId: '100446242',
      logo: 'http://res.imtt.qq.com/tagapp/qbfflogo.png',
      pkgName: 'com.tencent.feedsfast',
      scheme: 'ffbrowser://',
      schemeTl: 'https://news.html5.qq.com/feeds?ch=',
      downloadUrl: 'https://mdc.html5.qq.com/directdown?app=qbspeed&channel=11707',
      downloadUrlNotTBS: 'https://mdc.html5.qq.com/directdown?app=qbspeed&channel=11707'
    },
    kb: {
      app: 'reading',
      channel: '11809',
      appName: '看点快报',
      taskName: '看点快报-有看点 轻快点',
      wxAppId: 'wxe90c9765ad00e2cd',
      qqAppId: '101480433',
      logo: 'https://mat1.gtimg.com/www/images/pckuaibao/v0_logo_arc512.png',
      pkgName: 'com.tencent.reading',
      scheme: 'qnreading://',
      downloadUrl: `https://mdc.html5.qq.com/directdown?app=kb&channel=${kbChannel}`,
      downloadUrlNotTBS: `http://kuaibao.qq.com/newsDownLoad?refer=biznew&src=${kbRefer.toUpperCase()}`,
      schemeTl: `qnreading://tab_reading?tab=kuaibao&chlid=daily_timeline&from=${kbRefer}`,
      schemeMainTL: '',
      runUrl: `qnreading://article_detail?nm={docId}&from=${kbRefer}&refer=${kbRefer}`,  // 快报拉活URL
      freshUrl: `σσqnreadingpaste://article_detail?nm={docId}&function=qb_share&kd_channel_from=${kbRefer}&refer=${kbRefer}σσ`, // 快报拉新URL
      hotRank: {
        toMoreUrl: `qnreading://search_detail?keyword=%E7%83%AD%E6%90%9C%E6%A6%9C&from=${kbRefer}`,
        toSearchEndUrl: `qnreading://search_detail?keyword={keyword}&from=${kbRefer}`
      },
      apkBarUrl: `qnreading://tab_reading?tab=kuaibao&chlid=kb_news_zhanfeiyan&from=${kbRefer}`,  //战肺炎
      schemeNormalVideoTl: `qnreading://tab_reading?tab=video&chlid=kb_video_news&from=${kbRefer}`,
      schemeMiniVideoTl: `qnreading://tab_reading?tab=heart&chlid=kb_news_discovery&from=${kbRefer}`,
      mediaUrl: `qnreading://article_9563?chlid={mediaId}&from=${kbRefer}&refer=${kbRefer}`,
      backUrl: {
        new: 'https://kuaibao.qq.com/channelPromot/infoAggr?refer=h5_aggr&pageType=1',
        video: 'https://kuaibao.qq.com/channelPromot/infoAggr?refer=h5_aggr&pageType=2'
      },
      webViewUrl: `qnreading://webview?url={openUrl}&from=${kbRefer}`
    },
    extreme_qb: {
      app: 'sogouExtremeBrowser',
      channel: '11809',
      appName: '搜狗浏览器极速版',
      taskName: '搜狗浏览器极速版',
      wxAppId: 'wxe8019aad97b065f1',
      qqAppId: '1107878025',
      logo: detectEnv().isIos ? 'http://upage.imtt.qq.com/m_imtt/download-middle-page/images/extreme_ios.png' : 'http://upage.imtt.qq.com/m_imtt/download-middle-page/images/extreme_android.png',
      pkgName: detectEnv().isIos ? 'com.sogou.SogouExplorerMobile' : 'sogou.mobile.explorer',
      scheme: 'mttbrowser-sme://',
      schemeTl: 'https://news.html5.qq.com/feeds?ch=',
      schemeNormalVideoTl: 'qb://tab/video',
      schemeMiniVideoTl: 'qb://tab/video',
      schemeMainTL: detectEnv().isIos ? 'mttbrowser-sme://url=qb://home' : 'mttbrowser-sme://url=qb://home,openType=1',
      PosID: '',
      welfareCenter: 'https://qbact.html5.qq.com/newtickets?addressbar=hide&sdi_from=personalPage&isAutoLogin=true',
      downloadUrl: `https://appchannel.html5.qq.com/directdown?a=1&app=qqbrowser&channel=${qbChannel}`,      // TBS下载链接
      downloadUrlNotTBS: `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=${qbChannel}`, // 非TBS下载链接
      hotRank: {
        toMoreUrl: 'https://so.html5.qq.com/page/real/search_result?q=热搜榜&jump_from=2&entryTime=1582597704775&entryContent=搜索或输入网址&searchPageContent=搜索或输入网址&entryScene=001&entryStatus=001&searchPageStatus=002',
        toSearchEndUrl: 'https://so.html5.qq.com/page/real/search_result?q={keyword}'
      },
      downloadEcommerceUrl: `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=1100111356`,      // 电商渠道下载链接
      downloadEcommerceUrlNotTbs: `https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100111391`,      // 电商渠道分TBS下载链接
      downloadEcommerceUrliOS: `https://apps.apple.com/app/apple-store/id370139302?pt=69276&ct=191620203468&mt=8`,
      developer: '北京搜狗科技发展有限公司',
      privacyAgreementUrl: "https://privacy.tencent.com/document/priview/2491347092a64d7fa00cbc2bf68fbbbb?addressbar=hide",
      permissionUrl: "https://upage.imtt.qq.com/app-info/qb.html"
    },
    novel_qb: {
      app: 'sogouReaderBrowser',
      channel: '11809',
      appName: '搜狗免费小说极速版',
      taskName: '搜狗免费小说极速版',
      wxAppId: 'wx8d6a0ffb2a393f7b',
      qqAppId: '1106909767',
      logo: 'http://res.imtt.qq.com/tagapp/qblogo_android_512.png',
      pkgName: 'com.sogou.reader.free',
      scheme: 'mttbrowser-sr://',
      schemeTl: 'https://news.html5.qq.com/feeds?ch=',
      schemeNormalVideoTl: 'qb://tab/video',
      schemeMiniVideoTl: 'qb://tab/video',
      schemeMainTL: detectEnv().isIos ? 'qb://home' : 'qb://home,openType=1',
      PosID: qbPosID,
      welfareCenter: 'https://qbact.html5.qq.com/newtickets?addressbar=hide&sdi_from=personalPage&isAutoLogin=true',
      downloadUrl: `https://appchannel.html5.qq.com/directdown?a=1&app=qqbrowser&channel=${qbChannel}`,      // TBS下载链接
      downloadUrlNotTBS: `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=${qbChannel}`, // 非TBS下载链接
      hotRank: {
        toMoreUrl: 'https://so.html5.qq.com/page/real/search_result?q=热搜榜&jump_from=2&entryTime=1582597704775&entryContent=搜索或输入网址&searchPageContent=搜索或输入网址&entryScene=001&entryStatus=001&searchPageStatus=002',
        toSearchEndUrl: 'https://so.html5.qq.com/page/real/search_result?q={keyword}'
      },
      downloadEcommerceUrl: `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=1100111356`,      // 电商渠道下载链接
      downloadEcommerceUrlNotTbs: `https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100111391`,      // 电商渠道分TBS下载链接
      downloadEcommerceUrliOS: `https://apps.apple.com/app/apple-store/id370139302?pt=69276&ct=191620203468&mt=8`,
      developer: '北京搜狗科技发展有限公司',
      privacyAgreementUrl: "https://privacy.tencent.com/document/priview/2491347092a64d7fa00cbc2bf68fbbbb?addressbar=hide",
      permissionUrl: "https://upage.imtt.qq.com/app-info/qb.html"
    },
    young_qb:{
      app: 'bingo',
      channel: '11809',
      appName: 'Bingo',
      taskName: 'Bingo',
      wxAppId: 'wx994a1ffa1eb3c44c ',
      qqAppId: '100902965',
      logo: 'https://upage.imtt.qq.com/m_imtt/download-middle-page/images/Bingo.png',
      pkgName: detectEnv().isIos ? 'com.sogou.sogousearch' : 'com.sogou.activity.src',
      scheme: 'mttbrowser-sgs://',
      schemeTl: 'https://news.html5.qq.com/feeds?ch=',
      schemeNormalVideoTl: 'qb://tab/video',
      schemeMiniVideoTl: 'qb://tab/video',
      schemeMainTL: detectEnv().isIos ? 'mttbrowser-sgs://url=qb://home' : 'mttbrowser-sgs://url=qb://home,openType=1',
      PosID: qbPosID,
      welfareCenter: 'https://qbact.html5.qq.com/newtickets?addressbar=hide&sdi_from=personalPage&isAutoLogin=true',
      downloadUrl: `https://mdc.html5.qq.com/directdown?app=sgs&channel=1000000002`,      // TBS下载链接
      downloadUrlNotTBS: `https://mdc.html5.qq.com/directdown?app=sgs&channel=1000000002`, // 非TBS下载链接
      hotRank: {
        toMoreUrl: 'https://so.html5.qq.com/page/real/search_result?q=热搜榜&jump_from=2&entryTime=1582597704775&entryContent=搜索或输入网址&searchPageContent=搜索或输入网址&entryScene=001&entryStatus=001&searchPageStatus=002',
        toSearchEndUrl: 'https://so.html5.qq.com/page/real/search_result?q={keyword}'
      },
      downloadEcommerceUrl: `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=1100111356`,      // 电商渠道下载链接
      downloadEcommerceUrlNotTbs: `https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100111391`,      // 电商渠道分TBS下载链接
      downloadEcommerceUrliOS: `https://apps.apple.com/app/apple-store/id370139302?pt=69276&ct=191620203468&mt=8`,
      developer: '北京搜狗科技发展有限公司',
      privacyAgreementUrl: "https://privacy.qq.com/document/preview/0f01ea54ef954e3d9abd9d7161cb36c9",
      permissionUrl: "https://weapp.gtimg.com/mttyoung/file/permissions-details-bingo.html"
    }
}

// 手动刷新refer等
export const refreshAPP_INFO = () => {
  const { kbChannel, kbRefer, qbPosID = '816971', qbChannel='11813' } = getChannelRefer()

  APP_INFO = {
    qb: {
      app: 'qqbrowser',
      channel: '11809',
      appName: 'QQ浏览器',
      taskName: 'QQ浏览器—我的兴趣世界',
      wxAppId: 'wx64f9cf5b17af074d',
      qqAppId: '100446242',
      logo: 'http://res.imtt.qq.com/tagapp/qblogo_android_512.png',
      pkgName: 'com.tencent.mtt',
      scheme: 'mttbrowser://',
      schemeTl: 'https://news.html5.qq.com/feeds?ch=',
      schemeNormalVideoTl: 'qb://tab/video',
      schemeMiniVideoTl: 'qb://tab/video',
      PosID: qbPosID,
      welfareCenter: 'https://qbact.html5.qq.com/newtickets?addressbar=hide&sdi_from=personalPage&isAutoLogin=true',
      downloadUrl: `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=${qbChannel}`,      // TBS下载链接
      downloadUrlNotTBS: `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=${qbChannel}`, // 非TBS下载链接
      hotRank: {
        toMoreUrl: 'https://so.html5.qq.com/page/real/search_result?q=热搜榜&jump_from=2&entryTime=1582597704775&entryContent=搜索或输入网址&searchPageContent=搜索或输入网址&entryScene=001&entryStatus=001&searchPageStatus=002',
        toSearchEndUrl: 'https://so.html5.qq.com/page/real/search_result?q={keyword}'
      },
    },
    ff: {
      app: 'qbspeed',
      channel: '11707',
      appName: '天天快报极速版',
      taskName: '天天快报极速版-腾讯王卡,全网免流量',
      wxAppId: 'wx64f9cf5b17af074d',
      qqAppId: '100446242',
      logo: 'http://res.imtt.qq.com/tagapp/qbfflogo.png',
      pkgName: 'com.tencent.feedsfast',
      scheme: 'ffbrowser://',
      schemeTl: 'https://news.html5.qq.com/feeds?ch=',
      downloadUrl: 'https://mdc.html5.qq.com/directdown?app=qbspeed&channel=11707',
      downloadUrlNotTBS: 'https://mdc.html5.qq.com/directdown?app=qbspeed&channel=11707'
    },
    kb: {
      app: 'reading',
      channel: '11809',
      appName: '看点快报',
      taskName: '看点快报-有看点 轻快点',
      wxAppId: 'wxe90c9765ad00e2cd',
      qqAppId: '101480433',
      logo: 'https://mat1.gtimg.com/www/images/pckuaibao/v0_logo_arc512.png',
      pkgName: 'com.tencent.reading',
      scheme: 'qnreading://',
      downloadUrl: `http://dldir1.qq.com/dlomg/chuanyue/kuaibao_${kbChannel}.apk`,
      downloadUrlNotTBS: `http://kuaibao.qq.com/newsDownLoad?refer=biznew&src=${kbRefer.toUpperCase()}`,
      schemeTl: `qnreading://tab_reading?tab=kuaibao&chlid=daily_timeline&from=${kbRefer}`,
      runUrl: `qnreading://article_detail?nm={docId}&from=${kbRefer}&refer=${kbRefer}`,  // 快报拉活URL
      freshUrl: `σσqnreadingpaste://article_detail?nm={docId}&function=qb_share&kd_channel_from=${kbRefer}&refer=${kbRefer}σσ`, // 快报拉新URL
      hotRank: {
        toMoreUrl: `qnreading://search_detail?keyword=%E7%83%AD%E6%90%9C%E6%A6%9C&from=${kbRefer}`,
        toSearchEndUrl: `qnreading://search_detail?keyword={keyword}&from=${kbRefer}`
      },
      apkBarUrl: `qnreading://tab_reading?tab=kuaibao&chlid=kb_news_zhanfeiyan&from=${kbRefer}`,
      schemeNormalVideoTl: `qnreading://tab_reading?tab=video&chlid=kb_video_news&from=${kbRefer}`,
      schemeMiniVideoTl: `qnreading://tab_reading?tab=heart&chlid=kb_news_discovery&from=${kbRefer}`,
      mediaUrl: `qnreading://article_9563?chlid={mediaId}&from=${kbRefer}&refer=${kbRefer}`,
      backUrl: {
        new: '/v2/backNews',
        video: 'https://kuaibao.qq.com/channelPromot/infoAggr?refer=h5_aggr&pageType=2'
      }
    }
}
}
